export const LOGIN_USER_SAGA = "LOGIN_USER_SAGA";
export const LOGIN_USER_STAFF_SAGA = "LOGIN_USER_STAFF_SAGA";
export const SET_TIMER_LOGIN_SAGA = "SET_TIMER_LOGIN_SAGA";

export const ACTIVE_USER_SAGA = "ACTIVE_USER_SAGA";
export const RESEND_CODE_SAGA = "RESEND_CODE_SAGA";
